import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';

import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-resultados-casilla',
  templateUrl: './pregunta-resultados-casilla.component.html',
  styleUrls: ['./pregunta-resultados-casilla.component.scss']
})
export class PreguntaResultadosCasillaComponent implements OnInit {

  Search = "";

  constructor(public _globalService: GlobalesService,public themeService: ThemeService,) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
  }

}
